module.exports = __webpack_public_path__ + "static/CLIENT SERVICE AGREEMENT_CA-5edb7b45c01e47567fc7858cd194de7f.pdf";